import vegan from './Images/tagsallergens/vegan.svg';
import chicken from './Images/tagsallergens/chicken.svg';
import beef from './Images/tagsallergens/beef.svg';
import seafood from './Images/tagsallergens/seafood.svg';
import spicy from './Images/tagsallergens/spicy.svg';
import glutenfree from './Images/tagsallergens/glutenfree.svg';
import kosher from './Images/tagsallergens/kosher.svg';
import halal from './Images/tagsallergens/halal.svg';
import beer from './Images/tagsallergens/beer.svg';
import wine from './Images/tagsallergens/wine.svg';
import cocktail from './Images/tagsallergens/cocktail.svg';
import nonAlcohalic from './Images/tagsallergens/non-alcohalic.svg';
import milk from './Images/tagsallergens/milk.svg';
import eggs from './Images/tagsallergens/eggs.svg';
import wheat from './Images/tagsallergens/wheat.svg';
import soyabean from './Images/tagsallergens/soyabean.svg';
import mustard from './Images/tagsallergens/mustard.svg';
import sesame from './Images/tagsallergens/sesame.svg';
import celery from './Images/tagsallergens/celery.svg';
import crust from './Images/tagsallergens/crust.svg';
import fish from './Images/tagsallergens/fish.svg';
import oyster from './Images/tagsallergens/oyster.svg';
import treenut from './Images/tagsallergens/treenut.svg';
import peanut from './Images/tagsallergens/peanut.svg';
import assign1 from './Images/tagsallergens/assign1.svg';
import assign2 from './Images/tagsallergens/assign2.png';
import assign3 from './Images/tagsallergens/assign3.png';

export const tagsAlergensIconList: any = {
  1: vegan,
  2: chicken,
  3: beef,
  4: seafood,
  5: spicy,
  6: glutenfree,
  7: kosher,
  8: halal,
  9: beer,
  10: wine,
  11: cocktail,
  12: nonAlcohalic,
  13: milk,
  14: eggs,
  15: wheat,
  16: soyabean,
  17: mustard,
  18: sesame,
  19: celery,
  20: crust,
  21: fish,
  22: oyster,
  23: treenut,
  24: peanut,
  25: assign1,
  26: assign2,
  27: assign3,
};

export const icons = Object.keys(tagsAlergensIconList).map((key, index) => ({
  id: index + 1,
  iconName: key,
}));
